import { useAuth } from "react-oidc-context";
import { getEnvironment } from "./environment";

const ZITADEL_DEV_PROJECT_ID = "333195193979242871";
const ZITADEL_PROD_PROJECT_ID = "240280308371423234";

const v2LoginIssuers = [
	"https://login.dev.kultify.com",
	"https://login.kultify.com",
];

export function useIsKultifyAdmin(): boolean {
	const auth = useAuth();
	const user = auth.user;
	if (v2LoginIssuers.includes(user?.profile.iss ?? "")) {
		// next gen
		const projectId =
			getEnvironment() === "prod"
				? ZITADEL_PROD_PROJECT_ID
				: ZITADEL_DEV_PROJECT_ID;
		const roles =
			user?.profile?.[`urn:zitadel:iam:org:project:${projectId}:roles`] || {};
		const projectRoles = Object.keys(roles);
		return projectRoles.includes("kultifyAdmin");
	}
	// old login
	const roles: string[] = (user?.profile.roles as string[]) ?? [];
	return roles.includes("kultifyAdmin");
}
